module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "gallery",
    staticClass: "photo-gallery"
  }, [_c('StartPageSlider', {
    attrs: {
      "line-title-color": "#54CB6E",
      "title": "опережающая профессиональная подготовка"
    }
  }, _vm._l((_vm.data), function(item, index) {
    return _c('router-link', {
      key: index,
      staticClass: "photo-card d-flex flex-column",
      attrs: {
        "tag": "div",
        "to": {
          name: "blog-article",
          params: {
            id: item.id
          }
        }
      }
    }, [_c('div', {
      staticClass: "photo-card__title d-flex"
    }, [_c('AppSvgIcon', {
      staticClass: "d-flex",
      attrs: {
        "icon-name": _vm.$ui.IconSvgName.calendar
      }
    }), _c('span', [_vm._v(_vm._s(_vm.getDay(item.date_created)) + " " + _vm._s(_vm.getMonth(item.date_created)))])], 1), _c('div', {
      staticClass: "photo-card_photo--wrapper"
    }, [_c('AppPicture', {
      attrs: {
        "image": item.images.middleThumb,
        "fit-mode": "contain",
        "border-radius": "20px",
        "background-color": "inherit",
        "ratio": "3 / 2"
      }
    })], 1), _c('div', {
      staticClass: "photo-card_type"
    }, [_vm._v(_vm._s(_vm.getEventType(item)))]), _c('div', {
      staticClass: "photo-card_info ui_lines-limit-3"
    }, [_vm._v(_vm._s(item.title))])])
  }), 1), _c('AppButtonNew', {
    staticClass: "choose_button",
    attrs: {
      "type": _vm.getButtonType.big_button_stroke,
      "to": "/blog"
    }
  }, [_vm._v("ВСЕ СОБЫТИЯ"), _c('AppSvgIcon', {
    staticClass: "iconProgram",
    attrs: {
      "icon-name": _vm.$ui.IconSvgName.arrowLeft,
      "fill": "rgba(7, 124, 187, 1)"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d12ea012","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/components/AppDefaultLayout/components/sections/news/News.vue
// module id = 8bc969106eae83543f09
// module chunks = 0